import { render, staticRenderFns } from "./order-preview.vue?vue&type=template&id=4d37648a&scoped=true"
import script from "./order-preview.vue?vue&type=script&lang=js"
export * from "./order-preview.vue?vue&type=script&lang=js"
import style0 from "./order-preview.vue?vue&type=style&index=0&id=4d37648a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d37648a",
  null
  
)

export default component.exports